export default __webpack_public_path__ + "static/media/NkechiAbiah.fe551877.svg";